import React from 'react'
import ReactDOM from 'react-dom'
import { Provider as FetchProvider } from 'use-http'

import { DarkTheme, LightTheme, StardustProvider } from '@myxplor/stardust'

import config from '~/src/config'

import { getAuthToken } from '~/src/modules/auth'

import App from './pages'

const FETCH_OPTIONS = {
  cachePolicy: 'no-cache' as any,
  interceptors: {
    request: async ({ options }: any) => {
      return {
        ...options,
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
          'Content-Type': 'application/json',
        },
        mode: 'cors',
      }
    },
  },
  retries: 1,
  retryOn: async ({ attempt, error, response }: any) => {
    if (response.status === 401 && window.location.pathname !== '/login') {
      window.location.pathname = '/login'
    }

    return false
  },
}

const THEMES = {
  dark: DarkTheme,
  light: LightTheme,
}

const Root = () => (
  <StardustProvider activeTheme="light" themes={THEMES}>
    <FetchProvider url={config.PAPI_URL} options={FETCH_OPTIONS}>
      <App />
    </FetchProvider>
  </StardustProvider>
)

ReactDOM.render(<Root />, document.getElementById('root'))
